<div class="mainContent">	
		<div class="pageHeader" i18n>Help</div>
		<div class="column-Layout">
			<div class="firstDivision">
				<mat-card>
					<mat-card-header>
					  <mat-card-title i18n>About</mat-card-title>
					  <mat-card-subtitle i18n>
						Basic portal information
					  </mat-card-subtitle>
					</mat-card-header>
					
					<mat-card-content>					 
						  <mat-list>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> Licensee </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.name}}</mat-list-item>							  
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> License Validity </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.licenseValidity}}</mat-list-item>							  
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> Schema Info </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.schemaInfo}}</mat-list-item>								  
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> Number of Licenses </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.numberOfLicense}}</mat-list-item>								  
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> Number of Registered Devices</mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.numberOfDeviceConnected}}</mat-list-item>								 
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> API Version </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{about.apiVersion}}</mat-list-item>									  
							</div>
							<div mat-line>
								<mat-list-item i18n class="itemQuestion"> AdminPortal Version </mat-list-item>
								<mat-list-item role="listitem" class="itemAnswer" *ngIf="about"> {{Version}}</mat-list-item>									 
							</div>
						  </mat-list>						
					</mat-card-content>
				</mat-card>

				<mat-card class="supportCard">
					<mat-card-header>
					  <mat-card-title i18n>Support</mat-card-title>
					  <mat-card-subtitle i18n>
						Customer queries resolution assistance
					  </mat-card-subtitle>
					</mat-card-header>
										
					  <div class="supportItems">
						<div class="firstSupport">
							<mat-icon class="supportIcon">call</mat-icon>
							<p class="supportAnswer">+49 (0)7171-104777-0</p>
						</div>
						<div class="firstSupport">
							<mat-icon class="supportIcon">mail</mat-icon>
							<p class="supportAnswer">support@josoftware.de</p>
						</div>						
					  </div>					
				</mat-card>
			</div>

			<div class="detail-main">
				<p class="sectionHeader" i18n>Function Overview</p>
				<p class="sectionContent" i18n>
					cSAdminPortal is the web application created for the administration of, the mobile component of cableScout®, cSmobile. This software primarily imparts the ability to handle the users, regions and devices in connection with cSmobile. It also supports the configuration and management of redlinings, which are basically comments added to existing or non-existing network objects in the form of text and images. 
				</p>

				<p class="sectionHeader" i18n>User Roles</p>
				<p class="sectionContent" i18n>
					Companies may assign user roles to its users based on their needs and requirements. The user role determines the privileges that can be granted to the user through the role. It can also be utilized to set restrictions for a particular group of users.  cSAdminPortal offers 3 types of user roles:
				</p>
				<p class="subSectionHeader" i18n>1.	Super Admin</p>
				<p class="subSectionContent" i18n>					
					Super Admin is bestowed upon all the privileges of cSAdminPortal without any restrictions. User lock feature is not applicable to Super Admin.  Only Super Admin can reset own password.					
				</p>
				<p class="subSectionHeader" i18n>2.	Admin</p>
				<p class="subSectionContent" i18n>
					Admin can reset own password, but cannot lock/unlock himself. Admin can lock/unlock other users, except Super Admin. Admin can reset password of other users, except that of Super Admin.
				</p>
				<p class="subSectionHeader" i18n>3.	User</p>
				<p class="subSectionContent" i18n>
					Super Admin and Admin can login to cSAdminPortal, whereas login of User is prohibited.  Therefore, User cannot view or access any information in the portal.
				</p>

				<p class="sectionHeader" i18n>User Management</p>
				<p class="sectionContent" i18n>
					All information pertaining to the users of cSmobile are available in cSAdminPortal. The users list along with the number of users is displayed in Dashboard. A filter option is also provided to search for a particular user from the list. The display options icon can be used to hide/show cableScout users in the Users list. On selection of a user from the list, the user details page is displayed. This page contains information regarding the user login, profile and registration. The regions assigned to the user is also displayed.
				</p>
				<p class="sectionContent" i18n>The icons available in this page and corresponding features associated to it are as follows:</p>
				<p class="subSectionHeader" i18n>1.	Permissions </p>
				<p class="subSectionContent" i18n>To manage the access and visibility of the network objects and redlinings </p>
				<p class="subSectionHeader" i18n>2.	User lock/Unlock</p>
				<p class="subSectionContent" i18n>To prevent access of cSmobile to the user via lock and grant access via unlock</p>
				<p class="subSectionHeader" i18n>3.	Delete User</p>
				<p class="subSectionContent" i18n>To delete the selected user</p>				
				<p class="subSectionHeader" i18n>4.	Copy Activation code</p>
				<p class="subSectionContent" i18n>To copy the activation code for user registration</p>
				<p class="subSectionHeader" i18n>5.	Share Registration Info</p>
				<p class="subSectionContent" i18n>To share the activation code for user registration</p>
				<p class="subSectionHeader" i18n>6.	Add Profile</p>
				<p class="subSectionContent" i18n>To create a user profile, in case it does not exist already</p>
				<p class="subSectionHeader" i18n>7.	Edit Profile</p>
				<p class="subSectionContent" i18n>To edit information in user profile</p>
				<p class="subSectionHeader" i18n>8.	Reset Password</p>
				<p class="subSectionContent" i18n>To reset password of the user</p>
				<p class="subSectionHeader" i18n>9.	Regions</p>
				<p class="subSectionContent" i18n>To display the list of regions assigned to the user</p>

				<p class="sectionHeader" i18n>Device Management</p>
				<p class="sectionContent" i18n>
					All information pertaining to the devices in which cSmobile is installed are available in cSAdminPortal. The devices list along with the number of devices is displayed in Dashboard. A filter option is also provided to search for a particular device from the list. On selection of a device from the list, the device details page is displayed. This page contains information regarding the device, its associated redlinings and provision for device deregistration. A filter option is also provided to search for a particular redlining from the list.
				</p>
				<p class="sectionContent" i18n>
					The icons available in this page and corresponding features associated to it are as follows:
				</p>
				<p class="subSectionHeader" i18n>1.	Deregister device</p>
				<p class="subSectionContent" i18n>To generate device code for deregistration</p>
				<p class="subSectionHeader" i18n>2.	Copy Device code</p>
				<p class="subSectionContent" i18n>To copy device code</p>

				<p class="sectionHeader" i18n>Region Management</p>
				<p class="sectionContent" i18n>
					All information pertaining to the regions accessible in cSmobile are available in cSAdminPortal. The regions list along with the number of regions is displayed in Dashboard. A filter option is also provided to search for a particular region from the list. On selection of a region from the list, the region details page is displayed. Caching settings can be configured to set caching for one-time, weekly or daily basis. Users can be assigned to a region and region data validity can be set for a particular time period. Display options of the users list may be altered to hide or show cableScout users.
				</p>
				<p class="sectionContent" i18n>
					The icons available in this page and corresponding features associated to it are as follows:
				</p>
				<p class="subSectionHeader">1.	Cache</p>
				<p class="subSectionContent" i18n>To cache region</p>
				<p class="subSectionHeader" i18n>2.	Reset Cache</p>
				<p class="subSectionContent" i18n>To reset caching of region</p>

				<p class="sectionHeader" i18n>Redlinings</p>
				<p class="sectionContent" i18n>
					Redlinings can be created using existing as well as non-existing network objects, with default status ‘New’, in cSmobile. User can also add attachments in the form of images. These redlinings can be visualized in cSAdminPortal. The status of redlining can be changed from ‘New’ to ‘Completed’ once it is resolved. Only the redlinings with status ‘New’ will be made available in cSmobile on Sync. Specific redlinings can be searched using keywords to quickly locate specific records within the list. Status based sorting for easier management is also possible. In addition, redlinings can be deleted from the list whenever necessary.
				</p>

				<p class="sectionHeader" i18n>Settings</p>
				<p class="sectionContent" i18n>
					All the general settings pertaining to cSAdminPortal can be managed in this page. The user can define map attributes, define email settings, set language etc. It is also possible to export and import the settings.
				</p>

				<p class="sectionHeader" i18n>Configuration</p>
				<p class="sectionContent" i18n>
					The user can configure some exclusive settings in this page. The user can set the building colors, define redlining presets, create new user, choose buildings where the racks needs to be cached, view Schema Info and update Schema, start Db Precache etc. The management of Redlining Presets(create, edit and delete) are done in cSAdmin Portal and made available in cSmobile accordingly.
				</p>

				<p class="sectionHeader" i18n>Logs</p>
				<p class="sectionContent" i18n>
					The application logs and cache logs are available for the user to be downloaded in this page.
				</p>
			</div>
		</div>
	
</div>